import { makeStyles } from '@material-ui/core/styles';
import { CustomPalette } from '@nutrien/cxp-components';

export const useStyles = makeStyles({
  container: { maxWidth: '340px' },
  paper: {
    maxWidth: '432px',
    minWidth: '432px',
    marginLeft: '-100px',
    backgroundColor: CustomPalette.elevation.dp24Solid,
    overflow: 'hidden',
  },
  height: {
    height: '400px',
  },
  paper1: {
    maxWidth: '432px',
    minWidth: '432px',
    marginLeft: '-100px',
    backgroundColor: CustomPalette.elevation.dp24Solid,
    overflow: 'hidden',
  },
  header: {
    height: '100%',
    justifyContent: 'center',
    backgroundColor: 'rgb(64,64,64)',
    width: '100%',
    top: 0,
    position: 'sticky',
    alignContent: 'center',
    display: 'grid',
    paddingTop: '20px',
  },
  notification: {
    alignItems: 'center',
  },
  iconPos: {
    display: 'flex',
    paddingTop: '10px',
    justifyContent: 'center',
    alignSelf: 'stretch',
    '& .MuiSvgIcon-root': {
      width: '40px',
      height: '40px',
    },
  },
  siteCoordinatorName: {
    paddingTop: '10px',
    fontSize: '14px',
    display: 'flex',
  },
  role: {
    color: '#ffffffab',
  },
  alertText: {
    letterSpacing: '0.25px',
    paddingBottom: '15px',
    color: 'white',
  },
  timing: {
    paddingTop: '15px',
    letterSpacing: '0.4px',
    float: 'right',
    paddingRight: '10px',
  },
  divider: {
    width: '93%',
    background: 'rgba(255,255,255,0.4)',
    marginLeft: '15px',
  },
  showMoreGrid: {
    height: '50px',
    justifyContent: 'center',
    backgroundColor: 'rgb(64,64,64)',
    width: '100%',
    alignContent: 'center',
    display: 'grid',
    position: 'sticky',
    bottom: 0,
    cursor: 'pointer',
    '& > div > p': {
      border: 'none',
    },
  },
  body: {
    overflow: 'auto',
    height: '550px',
    background: 'rgb(46,46,46)',
  },
  body1: {
    background: 'rgb(46,46,46)',
  },
  noNotificationGrid: {
    height: '300px',
  },
  noNotificationLabel: {
    paddingTop: '10px',
  },
  notificationTabs: {
    marginLeft: 10,
    borderBottom: '1px solid grey',
    width: '70%',
  },
  notificationSubTab: {
    minWidth: 100,
    padding: 0,
    paddingLeft: 7,
    color: 'rgba(255, 255, 255, .87)',
    fontWeight: 400,
    '& .MuiTab-wrapper': {
      paddingTop: 10,
    },
  },
  markAsRead: {
    paddingTop: 22,
    paddingRight: 12,
    textAlignLast: 'right',
    cursor: 'pointer',
  },
  notificationGrid: {
    cursor: 'pointer',
  },
  notificationFirstGrid: {
    backgroundColor: 'rgb(64,64,64)',
  },
  trashIcon: {
    marginLeft: 43,
    marginTop: 5,
    cursor: 'pointer',
  },
  notficationGridDisabled: {
    backgroundColor: 'rgb(78,77,77)',
  },
  disabledAlertText: {
    color: '#b9b9b9',
    letterSpacing: '0.25px',
    paddingBottom: '15px',
  },
});
